import { FC, ReactNode } from "react";
import styles from "./style.module.scss";

interface Props {
  children: ReactNode;
}

export const PageContentContainer: FC<Props> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};
